import { SET_CRUMBS, SET_HAMBURGER_MENU, SET_PRESENTATION_MODE } from "common/reducers/common.actions";
import { List, Record } from "immutable";
import { RootActions, RootState } from ".";
import { CrumbRecord, setupBreadCrumbs } from "common/records/Crumb";
import { currentOrgName, currentUserOrgDescendantsCount } from "common/selectors/org.selectors";
import { currentJobName } from "common/selectors/job.selectors";

export const CommonStateRecord = Record({
  crumbs: List() as List<CrumbRecord>, // Used for bread crumbs UI
  hamburgerMenuOpen: false, // Used for hamburger menu UI
  presentationMode: false, // Used for presentation mode UI
});

export const initialState = CommonStateRecord();

export type RouterState = typeof initialState;

const model = "common";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case SET_CRUMBS: {
      const orgName = currentOrgName(state);
      const jobName = currentJobName(state);
      const userOrgCount = currentUserOrgDescendantsCount(state);

      const crumbs = setupBreadCrumbs(action.payload.pathname, orgName, jobName, userOrgCount, state);

      return state.setIn([model, "crumbs"], crumbs);
    }

    case SET_HAMBURGER_MENU: {
      return state.setIn([model, "hamburgerMenuOpen"], action.payload.isOpen);
    }

    case SET_PRESENTATION_MODE: {
      return state.setIn([model, "presentationMode"], action.payload.value);
    }

    default:
      return state;
  }
};
